(function() {

    'use strict';

    angular.module('app').
    controller('CarrierServiceProfileSetupController', CarrierServiceProfileSetupController);

    CarrierServiceProfileSetupController.$inject = ['$location', 'Carrier'];

    function CarrierServiceProfileSetupController($location, Carrier) {
        var vm = this;

        vm.currencyList = [
            {name: 'USD'},
            {name: 'PHP'},
            {name: 'USD'}
        ];

        init();

        function init() {
            getCarrierServiceProfileSetup();
        }

        function getCarrierServiceProfileSetup() {
            Carrier.getServiceProfileSetup(function(data) {
                vm.profile = data;
                //console.log('data', data);
            }, function(err) {
                console.log(err);
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/carriers/CarrierServiceProfileSetupController.js